import headerIcon from "../../../assets/images/avatar.svg";
import Dropdown from "react-bootstrap/Dropdown";
import "./header.component.scss";
import { useDispatch, useSelector } from "react-redux";
import { LogOut } from "../../../Redux/authSlice";
import {
  setLoaderFalse,
  setLoaderTrue,
  setLogoutLoading,
} from "../../../Redux/loaderSlice";
import { useEffect, useRef, useState } from "react";
import exportImages from "../../../assets/images/exportImages";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import group_3 from "../../../assets/images/in-progress/reseller_bank_img.svg";
import {
  setHealthAnalysisID,
  setOrgId,
  setOrgKey,
  setOrgName,
} from "../../../Redux/orgDetailsSlice";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { resetHID } from "../../../Redux/mainReportSlice";
import ClickOutside from "../ClickOutside";
import ListOptions from "../ListOptions";
import { breadcrumHistory } from "../../../Redux/navigationHistorySlice";
import { UpgradeCardSpecificModal } from "../Popup/UpgradeCardPopUp/UpgradeCard";
import { cardUpgradeData } from "../../../utils/upgradeCardsDetailedInfo";
import RecursiveCall from "./RecursiveCall";
import { bondScoreAnalysisSlice } from "../../../rtk-query/features/dashboard/bondScore/bondScoreAnalysisSlice";
import { setSkipFHSAPICall } from "../../../rtk-query/features/dashboard/financialHealthScore/financialHealthScoreAnalysisSlice";
import { paymentSuccessfulData } from "../Popup/ImageAndDataPopUp/DataContent";
import { ImageAndDataPopUp } from "../Popup/ImageAndDataPopUp/ImageAndDataPopUp";
import { SUBSCRIPTION, USER_TYPE } from "../../../utils/global";
import { setInfiniteBankPerformanceMetricsSlice } from "../../../rtk-query/features/infiniteBankPerformanceMetricsSlice/infiniteBankPerformanceMetricsSlice";
import { resetCampaignHistoryReducerState } from "../../../Redux/campaignHistorySlice";
import { usePermissions } from "../../../hooks/usePermissions";
import { PRIVILEGES } from "../../../utils/privileges";
import { resetCampaignPaginationReducerState } from "../../../Redux/paginationSlice";
import { useSubscription } from "../../../hooks/useSubscription";
import {
  resetFISubscriptionPrivileges,
  setSubscriptionPrivileges,
} from "../../../Redux/privilegesSlice";
import Notification from "../Notification/Notification";
import { useGetNotificationListQuery } from "../../../rtk-query/features/usernotification/notificationSlice";

const menuItems = [
  {
    label: "Email Templates",
    navUrl: "/bank/campaign-management/email-templates",
    privilege: PRIVILEGES.SHOW_EMAIL_TEMPLATE_MANAGEMENT,
  },
  {
    label: "Email Campaign",
    navUrl: "/bank/campaign-management/email-campaigns",
    privilege: PRIVILEGES.SHOW_EMAIL_CAMPAIGN_MANAGEMENT,
  },
  {
    label: "SMS Campaign",
    navUrl: "/bank/campaign-management/SMS_campaigns",
    privilege: PRIVILEGES.SHOW_SMS_CAMPAIGN_MANAGEMENT,
  },
  {
    label: "Consumer Lists",
    navUrl: "/bank/campaign-management/consumers-list",
    privilege: PRIVILEGES.SHOW_CONSUMER_LIST_MANAGEMENT,
  },
];

export const Header = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { hasPermission } = usePermissions();
  const { hasSubscription } = useSubscription();
  const forceLogout = useSelector((state) => state.stripeReducer.forceLogout);
  const loaderReducer = useSelector((state) => state.loaderReducer);
  const authReducer = useSelector((state) => state.authReducer);
  const userRole = authReducer?.userData?.role?.toLowerCase();
  const subscription = authReducer?.userData?.subscription?.toLowerCase();
  const isFirstLogin = authReducer?.userData?.isFirstLogin;
  const location = useLocation();
  const [currentPath, setCurrentPath] = useState(location?.pathname);
  const [BankNavLink] = useState(false);
  const [toggleOverlay, setToggleOverlay] = useState(false);
  const [upgradeCardModal, setUpgradeCardModal] = useState(false);
  const [selectedCardData, setSelectedCardData] = useState();
  const [showDropdown, setShowDropdown] = useState(false);
  const [hasUnread, setHasUnread] = useState(false);
  const profileBoxRef = useRef();

  const [fullName, setFullName] = useState(
    `${authReducer?.userData?.firstName}` +
      " " +
      `${authReducer?.userData?.lastName}`,
  );

  const subscriptionReducer = useSelector((state) => state.subscriptionReducer);
  const isFhsAvailable = subscriptionReducer?.isFhsAvailable;
  const isPro = subscriptionReducer?.isPro;
  const isMarketing = subscriptionReducer?.isMarketing;

  useEffect(() => {
    if (!window.location.href.includes("campaign-management")) {
      dispatch(resetCampaignHistoryReducerState(null));
    }
  });

  useEffect(() => {
    setFullName(
      `${authReducer?.userData?.firstName}` +
        " " +
        `${authReducer?.userData?.lastName}`,
    );
  }, [authReducer?.userData?.firstName, authReducer?.userData?.lastName]);

  useEffect(() => {
    if (BankNavLink === true) {
      setCurrentPath("none");
    } else {
      setCurrentPath(location.pathname);
    }
  });

  useEffect(() => {
    if (isFirstLogin && !authReducer?.userContactedSales) {
      const selectedCard = cardUpgradeData.find(
        (card) => card.name === "first_time_logged_in",
      );
      setUpgradeCardModal(true);
      setSelectedCardData(selectedCard);
    }
  }, []);

  const cacheImages = async (srcArray) => {
    const promises = await srcArray.map((src) => {
      return new Promise(function (resolve, reject) {
        const img = new Image();
        img.src = src;
        img.onload = resolve();
        img.onerror = reject();
      });
    });
    await Promise.all(promises);
  };

  const { data } = useGetNotificationListQuery();
  const notificationList = data?.data;

  useEffect(() => {
    setHasUnread(notificationList?.some((item) => item.readAt === null));
  }, [notificationList]);

  useEffect(() => {
    const imgs = [
      exportImages.missed_revenue_upgrade,
      exportImages.uplift_loans_upgrade,
      exportImages.boost_deposits_upgrade,
      exportImages.beat_the_competition_upgrade,
      exportImages.automated_marketing_upgrade,
      exportImages.contact_sales_team_upgrade,
      exportImages.contact_sales_team_success_upgrade,
      exportImages.consumer_behavior_upgrade,
      exportImages.insights_popup_bgimg,
      exportImages.mobile_static_img,
      exportImages.power_button,
      exportImages.power_button_blue,
      exportImages.icons_privacy_policy,
      exportImages.icons_privacy_policy_blue,
      exportImages.icons_settings,
      exportImages.icons_settings_bule,
      exportImages?.icon_role_star,
      exportImages.list_icon_view_details,
      exportImages.list_icon_approve,
      exportImages.list_icon_eye,
      exportImages.list_icon_trash,
      exportImages.list_icon_edit_grey,
      exportImages.list_icon_speed_test,
      exportImages.list_icon_edit,
      exportImages.list_icon_delete,
      exportImages.speedtest,
      exportImages.gauge_blue,
      exportImages.gauge_white,
      exportImages.trend_blue,
      exportImages.trend_white,
      group_3,
    ];
    cacheImages(imgs);
  }, []);

  const handleDropdownToggle = async (isOpen) => {
    if (loaderReducer?.performaLoading) {
      setShowDropdown(false); // block open while loading
      return;
    }
    setShowDropdown(isOpen);
  };

  const toggleButton = (
    <div className="d-flex">
      <div className="btn btn-icon btn-sm btn-active-bg-accent d-lg-none ms-1 ms-lg-6">
        <span className="svg-icon svg-icon-1 svg-icon-dark">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M21 7H3C2.4 7 2 6.6 2 6V4C2 3.4 2.4 3 3 3H21C21.6 3 22 3.4 22 4V6C22 6.6 21.6 7 21 7Z"
              fill="black"
            />
            <path
              opacity="0.3"
              d="M21 14H3C2.4 14 2 13.6 2 13V11C2 10.4 2.4 10 3 10H21C21.6 10 22 10.4 22 11V13C22 13.6 21.6 14 21 14ZM22 20V18C22 17.4 21.6 17 21 17H3C2.4 17 2 17.4 2 18V20C2 20.6 2.4 21 3 21H21C21.6 21 22 20.6 22 20Z"
              fill="black"
            />
          </svg>
        </span>
      </div>
      <div onClick={(e) => e.stopPropagation()}></div>
    </div>
  );

  const changeNavLink = () => {
    setCurrentPath(location.pathname);
    props.setNavBar(false);
    dispatch(resetCampaignPaginationReducerState(null));
    dispatch(
      breadcrumHistory({
        cardName: "",
        currentPath: location.pathname,
        checkPathFromCluster: false,
        hid: "",
      }),
    );
  };

  const LogoutHandler = () => {
    dispatch(setSkipFHSAPICall(true));
    dispatch(setLogoutLoading(true));
    dispatch(setLoaderTrue());
    dispatch(setOrgId(""));
    dispatch(setOrgName(""));
    dispatch(setOrgKey(""));
    dispatch(resetHID());
    dispatch(setHealthAnalysisID(null));
    dispatch(setInfiniteBankPerformanceMetricsSlice());
    dispatch(bondScoreAnalysisSlice.util.resetApiState());
    const scriptElement = document.querySelector(
      'script[src="./Bond_Component.js"]',
    );
    scriptElement?.remove();
    localStorage.clear();
    dispatch(resetCampaignPaginationReducerState(null));
    setTimeout(async () => {
      await dispatch(LogOut())
        .unwrap()
        .then(() => {
          dispatch(setLoaderFalse());
          navigate("/user/login");
        })
        .catch((err) => {
          dispatch(setLoaderFalse());
        });
    }, 2000);
  };

  const [expanded, setExpanded] = useState(false); // Use state to toggle Navbar expansion
  const orgReducer = useSelector((state) => state.orgReducer);
  const toggleNavbar = () => {
    setExpanded(!expanded);
  };

  const handleEmailCampaignsMenuClick = (event, selectedMenu) => {
    event.preventDefault();
    if (!hasSubscription(selectedMenu?.privilege)) {
      return;
    }
    navigate(selectedMenu?.navUrl);
    setToggleOverlay(false);

    dispatch(resetCampaignPaginationReducerState(null));
    // if (
    //   selectedMenu.label === menuItems[3].label ||
    //   selectedMenu.label === menuItems[0].label
    // ) {
    dispatch(
      breadcrumHistory({
        cardName: "",
        currentPath: location.pathname,
        checkPathFromCluster: false,
        hid: "",
      }),
    );
  };

  const handleClickSettings = () => {
    navigate("/pages/settings");
  };

  return (
    <>
      <RecursiveCall />
      <div className={`bond-header-container`}>
        <div
          className={`d-flex align-items-stretch justify-content-center fixed-header bond-header`}
        >
          <Navbar expand="lg" className="container fixed-header">
            <Container fluid>
              <Navbar.Brand>
                <div
                  className="aside-logo pe-2"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <img
                    className={`pe-4 ${
                      ![
                        "/user/bankperformancemetrics",
                        "/pages/faq",
                        "/user-management/user-management-list",
                      ].some((sub) => window.location.pathname.includes(sub)) ||
                      // userRole !== USER_TYPE.SUPER_ADMIN.toLowerCase() &&
                      (userRole?.toLowerCase() !==
                        USER_TYPE.RESELLER.toLowerCase() &&
                        userRole?.toLowerCase() !==
                          USER_TYPE.SUPER_ADMIN.toLowerCase())
                        ? "logo-right-border"
                        : ""
                    }`}
                    alt="Logo"
                    src={exportImages?.logo_black_img}
                  />

                  <span className={`ps-4 fw-bolder fi-name-header`}>
                    {![
                      "/user/bankperformancemetrics",
                      "/pages/faq",
                      "/user-management/user-management-list",
                    ].some((sub) => window.location.pathname.includes(sub)) ||
                    // userRole !== USER_TYPE.SUPER_ADMIN.toLowerCase() &&
                    (userRole?.toLowerCase() !==
                      USER_TYPE.RESELLER.toLowerCase() &&
                      userRole?.toLowerCase() !==
                        USER_TYPE.SUPER_ADMIN.toLowerCase())
                      ? // ? transformBankName(orgReducer?.selectedFI?.org_name)
                        orgReducer?.selectedFI?.org_name
                      : ""}
                  </span>
                </div>
              </Navbar.Brand>
              <Navbar.Collapse id="navbarScroll">
                <Nav
                  className="ms-auto my-2 my-lg-0 d-flex align-items-center nav-header"
                  style={{ maxHeight: "100px" }}
                  navbarScroll
                  overlay={"true"}
                >
                  <NavLink
                    to={
                      userRole === "reseller" || userRole === "bond-admin"
                        ? `/user/bankperformancemetrics`
                        : `/bank/health-analysis/report/${
                            orgReducer?.healthAnalysisID?.uid
                              ? orgReducer?.healthAnalysisID?.uid
                              : "no-analysis-id"
                          }`
                    }
                    className="menu-item-header"
                    onClick={() => {
                      dispatch(
                        setSubscriptionPrivileges(
                          authReducer.userData.product_Privileges,
                        ),
                      );
                      dispatch(resetFISubscriptionPrivileges());
                      changeNavLink();
                    }}
                  >
                    <div
                      className={
                        currentPath.includes("/bank/health-analysis/report/") ||
                        currentPath.includes("/user/bankperformancemetrics")
                          ? " menu-link  active-link py-2  "
                          : "menu-link py-2 "
                      }
                    >
                      <span className="menu-title">Home</span>
                    </div>
                  </NavLink>

                  {
                    // (userRole === USER_TYPE.USER.toLowerCase() ||
                    //   userRole === USER_TYPE.ADMIN.toLowerCase() ||
                    //   userRole === USER_TYPE.RESELLER.toLowerCase() ||
                    //   userRole === USER_TYPE.SUPER_ADMIN.toLowerCase()) &&
                    //   subscription === SUBSCRIPTION.PRO.toLowerCase() &&
                    //   isFhsAvailable
                    hasPermission(PRIVILEGES.SHOW_HISTORY_PAGE) &&
                      (hasSubscription(PRIVILEGES.SHOW_HISTORY_PAGE) ? (
                        <NavLink
                          to={"/bank/health-analysis/history"}
                          className="menu-item-header"
                          onClick={() => changeNavLink()}
                        >
                          <div
                            className={
                              currentPath === "/bank/health-analysis/history"
                                ? " menu-link  active-link py-2  "
                                : "menu-link py-2 "
                            }
                          >
                            <span className="menu-title">History</span>
                          </div>
                        </NavLink>
                      ) : (
                        <div className="menu-link py-2 disabled">
                          <span className="menu-title">History</span>
                        </div>
                      ))
                  }

                  {/* {hasPermission(PRIVILEGES.SHOW_CAMPAIGN_MANAGEMENT) &&
                    userRole !== USER_TYPE.RESELLER.toLowerCase() && (
                      <Nav.Link
                        style={{
                          width: 0,
                          paddingLeft: 0,
                          paddingRight: "1.1rem",
                          margin: 0,
                          display: "inline-grid",
                          alignItems: "center",
                          marginTop: "-0.5rem",
                          display:
                            // authReducer?.userData?.role !== "Bond-Admin" ||
                            authReducer?.userData?.role !== "Reseller"
                              ? "none"
                              : "block",
                        }}
                      >
                        <NavLink
                          onClick={(e) => {
                            e.preventDefault();
                            const selectedCard = cardUpgradeData.find(
                              (card) => card.name === "upgrade_email_campaign",
                            );
                            setUpgradeCardModal(true);
                            setSelectedCardData(selectedCard);
                          }}
                        >
                          <img
                            alt="icon"
                            width="20"
                            height="20"
                            src={exportImages.dashboard_upgrade_lock}
                            className="img-fluid-header"
                            style={{
                              display: isPro
                                ? isMarketing
                                  ? "none"
                                  : "block"
                                : "none",
                            }}
                          />
                        </NavLink>
                      </Nav.Link>
                    )} */}

                  {
                    // userRole !== USER_TYPE.RESELLER.toLowerCase() &&
                    // subscription === SUBSCRIPTION.PRO.toLowerCase() &&
                    // isPro &&
                    // isMarketing &&
                    hasPermission(PRIVILEGES.SHOW_CAMPAIGN_MANAGEMENT) &&
                      (hasSubscription(PRIVILEGES.SHOW_CAMPAIGN_MANAGEMENT) ? (
                        <NavLink>
                          <div
                            className={
                              currentPath.includes("campaign-management")
                                ? " menu-link active-link "
                                : "menu-link"
                            }
                            onMouseEnter={() => setToggleOverlay(true)} // Add this line
                            onMouseLeave={() => setToggleOverlay(false)}
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              setToggleOverlay(true);
                            }}
                          >
                            <span className="menu-title">Campaigns</span>
                            {toggleOverlay && (
                              <ClickOutside
                                onClick={() => {
                                  setToggleOverlay(false);
                                  dispatch(
                                    breadcrumHistory({
                                      cardName: "",
                                      currentPath: "",
                                      checkPathFromCluster: false,
                                      hid: orgReducer?.healthAnalysisID?.uid
                                        ? orgReducer?.healthAnalysisID?.uid
                                        : "",
                                    }),
                                  );
                                }}
                              >
                                <div className="overlayPanel py-0 px-0">
                                  <ListOptions
                                    options={menuItems}
                                    onClick={handleEmailCampaignsMenuClick}
                                  />
                                </div>
                              </ClickOutside>
                            )}
                          </div>
                        </NavLink>
                      ) : (
                        <div className="menu-link py-2 disabled">
                          <span className="menu-title">Campaigns</span>
                        </div>
                      ))
                  }

                  {hasPermission(PRIVILEGES.SHOW_USER_MANAGEMENT) &&
                    (hasSubscription(PRIVILEGES.SHOW_USER_MANAGEMENT) ? (
                      <NavLink
                        to={"/bank/user-management/user-management-list"}
                        className="menu-item-header"
                        onClick={() => changeNavLink()}
                      >
                        <div
                          className={
                            currentPath ===
                            "/bank/user-management/user-management-list"
                              ? " menu-link active-link py-2  "
                              : "menu-link py-2 "
                          }
                        >
                          <span className="menu-title">Users</span>
                        </div>
                      </NavLink>
                    ) : (
                      <div className="menu-link py-2 disabled">
                        <span className="menu-title">Users</span>
                      </div>
                    ))}

                  <NavLink
                    to={"/pages/faq"}
                    className="menu-item-header"
                    onClick={() => changeNavLink()}
                  >
                    <div
                      className={
                        currentPath === "/pages/faq"
                          ? " menu-link active-link py-2  "
                          : "menu-link py-2 "
                      }
                    >
                      <span className="menu-title">Support</span>
                    </div>
                  </NavLink>
                </Nav>
              </Navbar.Collapse>

              <Navbar.Toggle
                aria-controls={`navbarScroll`}
                children={toggleButton}
                style={{
                  alignSelf: "end",
                  textAlign: "left",
                  marginLeft: "auto",
                }}
                onClick={toggleNavbar}
              />

              <div className="d-flex align-items-center ">
                <div
                  style={{ display: "none" }}
                  className="dropdown notificationDropdown mx-5"
                >
                  <button
                    className="btn btn-icon btn-sm btn-active-bg-accent badge rounded-pill bg-light position-relative"
                    type="button"
                    id="dropdownMenuButton2"
                    data-bs-toggle="dropdown"
                    aria-expanded="true"
                  >
                    <img alt="icon" src={exportImages?.notification} />
                    <span className="position-absolute badge-number top-0 start-100 translate-middle p-2 btn-bond bg-success border border-light rounded-circle">
                      <span></span>
                    </span>
                  </button>

                  <ul
                    className="dropdown-menu p-0 w-300px w-xxl-400px"
                    aria-labelledby="dropdownMenuButton2"
                  >
                    <li className="dropdownTitle"> New Notifications </li>
                    <li>
                      <hr className="dropdown-divider m-0" />
                    </li>
                    <div className="notificationData">
                      <li>
                        <div className="d-flex align-items-center">
                          <div className="flex-shrink-0 w-35px w-xxl-50px">
                            <img
                              src="assets/images/icon_notification_bank_health_score.png"
                              className="img-fluid"
                              alt="icon_notification_bank_health_score.png"
                            />
                          </div>

                          <div className="flex-grow-1 ms-3">
                            <label className="title"></label>
                            <p className="mb-0 subTitle"></p>
                          </div>
                        </div>
                      </li>
                    </div>
                  </ul>
                </div>
                <Dropdown
                  show={showDropdown}
                  className=" d-block d-sm-block d-md-block d-lg-block"
                  onToggle={handleDropdownToggle}
                >
                  <Dropdown.Toggle
                    className="btn btn-icon btn-sm btn-active-bg-accent"
                    id="dropdownMenuButton2"
                  >
                    <img
                      alt="icon"
                      src={exportImages?.icon_new_analysis_notification}
                      className="img-fluid position-relative"
                    />

                    <img
                      src={exportImages?.icon_notification_badge}
                      className="img-fluid position-absolute top-0"
                      style={{
                        right: "8px",
                        display: hasUnread ? "block" : "none",
                      }}
                    />
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="notification-dropdown user-dropdown">
                    <Notification LogoutHandler={LogoutHandler} />
                  </Dropdown.Menu>
                </Dropdown>

                <Dropdown className="userIconDropdown  d-block d-sm-block d-md-block d-lg-block  ">
                  <Dropdown.Toggle
                    className="btn btn-icon btn-sm btn-active-bg-accent"
                    type="image"
                    id="dropdownMenuButton1"
                    ref={profileBoxRef}
                    data-bs-toggle="dropdown"
                    aria-expanded="true"
                  >
                    <img alt="icon" src={headerIcon} className="img-fluid" />
                  </Dropdown.Toggle>

                  <Dropdown.Menu
                    className=" p-0 user-dropdown"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <div
                      className="rightArrow"
                      style={{
                        display: "block",
                        border: "none",
                        top: "-6px",
                        right: "28px",
                      }}
                    ></div>
                    <Dropdown.ItemText>
                      <div className="profile-popup d-flex flex-column align-items-center justify-content-center">
                        <img
                          alt="icon"
                          src={headerIcon}
                          className=" user-avtar mb-3"
                        />
                        <span
                          className="fw-bolder text-wrap"
                          style={{ fontSize: "16px" }}
                          title={fullName}
                        >
                          {fullName}
                        </span>
                        <span
                          className=" text-steel text-wrap"
                          style={{ fontSize: "12px" }}
                          title={authReducer?.userData?.userName}
                        >
                          {" "}
                          {authReducer?.userData?.userName}
                        </span>
                        <div
                          style={{ color: "#6b7de5", marginTop: "5px" }}
                          className="d-flex justify-content-center h-100"
                        >
                          <img
                            src={exportImages?.icon_role_star}
                            style={{
                              marginRight: "6px",
                              height: "16px",
                              width: "16px",
                            }}
                          />
                          <span className="">
                            {authReducer?.userData?.role}{" "}
                          </span>
                        </div>
                        <div
                          className={
                            authReducer?.userData?.role === "Reseller" ||
                            authReducer?.userData?.role === "Bond-Admin"
                              ? "d-none"
                              : "d-flex justify-content-center h-100"
                          }
                        >
                          <span className="badge p-3">
                            {authReducer?.userData?.subscriptionName}
                          </span>
                        </div>
                      </div>
                    </Dropdown.ItemText>
                    <Dropdown.Divider />
                    <Dropdown.Item className="p-0 w-100">
                      <button
                        type="button"
                        class="btn btn-link w-100 menu-btn logout-button"
                        onClick={handleClickSettings}
                      >
                        <img
                          src={exportImages?.icons_settings}
                          className="img-default"
                          style={{ marginRight: "0.462rem" }}
                        />{" "}
                        <img
                          src={exportImages?.icons_settings_bule}
                          className="img-hover"
                          style={{ marginRight: "0.462rem" }}
                        />{" "}
                        Settings
                      </button>
                    </Dropdown.Item>
                    <Dropdown.Item className="p-0 w-100">
                      <button
                        type="button"
                        class="btn btn-link w-100 menu-btn logout-button"
                        onClick={() =>
                          window.open(
                            "https://www.bond.ai/terms-conditions#privacy-policy",
                            "_blank",
                          )
                        }
                      >
                        <img
                          src={exportImages?.icons_privacy_policy}
                          className="img-default"
                          style={{ marginRight: "0.462rem" }}
                        />{" "}
                        <img
                          src={exportImages?.icons_privacy_policy_blue}
                          className="img-hover"
                          style={{ marginRight: "0.462rem" }}
                        />{" "}
                        Privacy Policy
                      </button>
                    </Dropdown.Item>
                    <Dropdown.Item className="p-0 w-100">
                      <button
                        type="button"
                        class="btn btn-link w-100 menu-btn logout-button"
                        onClick={() => LogoutHandler()}
                      >
                        <img
                          src={exportImages?.power_button}
                          className="img-default"
                          style={{ marginRight: "0.462rem" }}
                        />{" "}
                        <img
                          src={exportImages?.power_button_blue}
                          className="img-hover"
                          style={{ marginRight: "0.462rem" }}
                        />{" "}
                        Logout
                      </button>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </Container>
          </Navbar>
        </div>
      </div>
      <UpgradeCardSpecificModal
        show={upgradeCardModal}
        onHide={() => setUpgradeCardModal(false)}
        cardData={selectedCardData}
      />
      <ImageAndDataPopUp
        show={forceLogout}
        // onHide={() => setInsightsModal(false)}
        modalData={paymentSuccessfulData}
      />
    </>
  );
};
